// Add functionality for the clear button to set the search field value to an empty string.
const search_clear_buttons = document.querySelectorAll('.search-form__clear');

for( let i=0; i<search_clear_buttons.length; i++){
	search_clear_buttons[i].addEventListener( 'click', ali_clear_search_form );
}

function ali_clear_search_form(e){

	let parent_form = e.target;
	do {
		parent_form = parent_form.parentNode;
	}
	while( !parent_form.classList.contains('search-form') && parent_form !== document.body );

	if( parent_form.classList.contains('search-form') ){
		let search_field = parent_form.querySelector('.search-form__s');
		search_field.value = '';
		search_field.parentNode.classList.remove('has-value');
	}

}



// Show the clear button only when the search field is not emtpy.
const search_fields = document.querySelectorAll('.search-form__s');
// console.log(search_fields);

for( let i=0; i<search_fields.length; i++){
	search_fields[i].addEventListener( 'input', ali_search_field_onInput );
	ali_check_search_has_value( search_fields[i] );
}

function ali_search_field_onInput(e){
	ali_check_search_has_value( e.target );
}

function ali_check_search_has_value( search_field ){
	if( search_field.value ){
		search_field.parentNode.classList.add('has-value');
	} else {
		search_field.parentNode.classList.remove('has-value');
	}
}
